/* eslint-disable react/react-in-jsx-scope */
import { Box } from '@material-ui/core';

function AccountingDivisor() {
  return (
    <Box
      style={{
        width: '100%',
        minWidth: '300px',
        borderBottom: '0.1px solid #0b5b5c3b',
        marginBottom: '8px',
        marginTop: '8px',
      }}
    />
  );
}

export function AccountingDivisorDarken() {
  return (
    <Box
      style={{
        width: '100%',
        minWidth: '300px',
        borderBottom: '2px solid #0b5b5c3b',
        marginBottom: '8px',
        marginTop: '8px',
      }}
    />
  );
}

export default AccountingDivisor;
